import { useSuspenseQuery } from '@tanstack/react-query'
import { useState } from 'react'

import { type CarouselApi } from '@/components/carousel/carousel'

import { getCaseExtraInfoQuery } from '@/lib/queries/business/v3/case-extra/queries'
import { type ValueOf } from '@/lib/utils/type'

import { useFindTargetCase } from '../../../../hooks/use-find-target-case'
import { useUpdateVisaBulletinInfoDialogStore } from '../../../stores/use-update-visa-bulletin-info-dialog-store'
import { useVisaBulletinTrendDialogStore } from '../../../stores/use-visa-bulletin-trend-dialog-store'
import { VISA_BULLETIN_TYPE_MAP } from '../constants/visa-bulletin-tab'

type VISA_BULLETIN_TYPE = ValueOf<typeof VISA_BULLETIN_TYPE_MAP>

export const useVisaBulletinInfo = () => {
  const [visaBulletinType, setVisaBulletinType] = useState<VISA_BULLETIN_TYPE>(VISA_BULLETIN_TYPE_MAP['this-month'])
  const [carouselApi, setCarouselApi] = useState<CarouselApi | null>(null)

  const { targetCase } = useFindTargetCase()
  const { data: dataCaseExtraInfo } = useSuspenseQuery(getCaseExtraInfoQuery(targetCase?.case_id))
  const currentVisaBulletinData = dataCaseExtraInfo?.visaBulletin?.current
  const nextVisaBulletinData = dataCaseExtraInfo?.visaBulletin?.next

  const { openDialog: openUpdateDialog } = useUpdateVisaBulletinInfoDialogStore()

  const { openDialog: openVisaBulletinTrendDialog } = useVisaBulletinTrendDialogStore()

  // These functions are intentionally kept separate to allow for future extendability
  const handleClickSetVisaBulletinAlertButton = () => {
    openUpdateDialog()
  }
  const handleClickUpdateCaseInfoButton = () => {
    openUpdateDialog()
  }
  const handleClickMoreInfoButton = () => {
    openVisaBulletinTrendDialog()
  }

  const handleChangeTabValue = (value: string) => {
    if (!carouselApi) {
      return
    }

    if (value === VISA_BULLETIN_TYPE_MAP['this-month']) {
      setVisaBulletinType(VISA_BULLETIN_TYPE_MAP['this-month'])
      carouselApi.scrollTo(0)
    } else if (value === VISA_BULLETIN_TYPE_MAP['next-month']) {
      setVisaBulletinType(VISA_BULLETIN_TYPE_MAP['next-month'])
      carouselApi.scrollTo(1)
    } else {
      console.error(`Unknown visa bulletin type: ${value}`)
    }
  }

  return {
    visaBulletinType,
    currentVisaBulletinData,
    nextVisaBulletinData,
    priorityDate: dataCaseExtraInfo?.priorityDate,
    existsVisaBulletinData: !!currentVisaBulletinData || !!nextVisaBulletinData,
    setCarouselApi,
    handleClickSetVisaBulletinAlertButton,
    handleClickUpdateCaseInfoButton,
    handleClickMoreInfoButton,
    handleChangeTabValue,
  }
}
